import styles from './SolutionDefault.module.scss';

import React, { FC, HTMLAttributes } from 'react';

import type { SolutionPickerModule as SolutionPickerModuleType } from 'api/contentful/contentTypes.cloverdotcom';
import { Grid } from 'components/Grid/Grid';
import { GridContainer } from 'components/GridContainer/GridContainer';
import type { FlatEntry } from 'services/cms/flattenContentful';

import { DefaultCard } from './DefaultCard';
import { DefaultTitle } from './DefaultTitle';

interface ISolutionDefaultProps extends HTMLAttributes<HTMLElement> {
  entry?: FlatEntry<SolutionPickerModuleType>;
}

export const SolutionDefault: FC<ISolutionDefaultProps> = ({ entry }) => {
  if (!entry) return null;

  const { items = [] } = entry;

  return (
    <>
      <GridContainer justifyContent="center">
        <Grid item xs={12} md={9} lg={10} xl={8}>
          <DefaultTitle entry={entry} />
        </Grid>
      </GridContainer>
      <GridContainer justifyContent="center" maxWidth="lg" className={styles.solutionPickerModuleButtons}>
        <Grid container item xs={12} lg={10} xl={12} gutter>
          {items.map(item => (
            <DefaultCard item={item} key={item.title} />
          ))}
        </Grid>
      </GridContainer>
    </>
  );
};

SolutionDefault.displayName = 'SolutionDefault';
